import { RawMaterialDto } from "@sharedcommon/rest/data.restservice";
import { RawmaterialOrSampleStatus } from "./rawmaterial-or-sample-status.utils"
import { SampleDashboardDto } from "@sharedcommon/model/sample/sample-dashboard.model";

export class RawMaterialOrSampleUtil {
  /**
   * Check if the raw mat or sample is archived or not
   * @param product a raw material of a sample
   * @returns true if archived
   */
  static readonly isArchived = (product: RawMaterialDto|SampleDashboardDto): boolean => {
    return product.status === RawmaterialOrSampleStatus.ARCHIVED;
  }

  /**
   * Check if the raw mat or sample is archived or not
   * @param product a raw material of a sample
   * @returns true if not archived
   */
  static readonly isNotArchived = (product: RawMaterialDto|SampleDashboardDto): boolean => {
    return !this.isArchived(product);
  }

  /**
   * Check if the raw mat or sample is enabled or not
   * @param product a raw material of a sample
   * @returns true if enabled
   */
  static readonly isEnabled = (product: RawMaterialDto|SampleDashboardDto): boolean => {
    return product.status === RawmaterialOrSampleStatus.ENABLED;
  }

  /**
   * Check if the raw mat or sample is disabled or not
   * @param product a raw material of a sample
   * @returns true if disabled
   */
  static readonly isDisabled = (product: RawMaterialDto|SampleDashboardDto): boolean => {
    return product.status === RawmaterialOrSampleStatus.DISABLED;
  }

  /**
   * Check if the raw mat or sample can be enabled or not
   * @param product a raw material of a sample
   * @returns true if can be enabled
   */
  static readonly canBeEnabled = (product: RawMaterialDto|SampleDashboardDto): boolean => {
    return !this.isEnabled(product) && this.isDisabled(product);
  }

  /**
   * Check if the raw mat or sample is locked or not
   * @param product a raw material of a sample
   * @returns true if locked
   */
  static readonly isLocked = (product: RawMaterialDto|SampleDashboardDto): boolean => {
    let locked = false;
    if (product?.lockDate) {
      const lockDate = new Date(product.lockDate);
      lockDate.setHours(lockDate.getHours() + 1);
      if (new Date() < lockDate) {
        locked = true;
      }
    }
    if(product.status === RawmaterialOrSampleStatus.DISABLED  || product.status === RawmaterialOrSampleStatus.ARCHIVED){
      locked = true;
    }
    return locked;
  }

  /**
   * Check if the raw mat or sample can be deleted or not
   * @param product a raw material of a sample
   * @returns true if it can be deleted or not
   */
  static readonly canBeDeleted = (product: RawMaterialDto|SampleDashboardDto): boolean => {
    const isLocked: boolean = this.isLocked(product);
    return !isLocked || (isLocked && this.isDisabled(product)) || this.isArchived(product);
  }
}
